import { StatsApiClient } from "../../clients/stats-client";
import { PlayerProfile, PlayerShort, ShortSteamPlayer } from "./models/players";

export class PlayersRepository {
    private _client: StatsApiClient;

    constructor() {
        this._client = new StatsApiClient('/api/v2/players');
    }

    async get(playerId: number): Promise<ApiDataResponse<PlayerProfile>> {
        return await this._client.get<PlayerProfile>("", {
            playerId: playerId.toString()
        });
    }

    async getShort(playerId: number): Promise<ApiDataResponse<PlayerShort>> {
        return await this._client.get<PlayerShort>("short", {
            playerId: playerId.toString()
        });
    }

    async getSteamProfile(playerId: number): Promise<ApiDataResponse<ShortSteamPlayer>> {
        return await this._client.get<ShortSteamPlayer>("steam-profile", {
            playerId: playerId.toString()
        });
    }
}